/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ImportRowStatus {
    Good = 0,
    Warning = 1,
    Error = 2,
    Added = 3,
    Skipped = 4,
    Duplicate = 5,
}
